import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

export const BRAND_FALLBACK = 'RE/MAX Altium';
export const BRAND_LOGO = '/img/altium-logo.png';
export const BRAND_LOGO_ON_DARK = '/img/altium-logo-white.png';

const filled = (value) => (typeof value === 'string' ? value.trim() : '');

export function resolveBrandName(branding) {
    return filled(branding?.brand_name) || BRAND_FALLBACK;
}

export function resolveLogo(branding, fallback = BRAND_LOGO) {
    return filled(branding?.headerLogo) || fallback;
}

export function useBranding() {
    const page = usePage();

    const brandName = computed(() => resolveBrandName(page.props.branding));
    const logoSrc = computed(() => resolveLogo(page.props.branding));
    const hasCustomLogo = computed(() => filled(page.props.branding?.headerLogo) !== '');

    return { brandName, logoSrc, hasCustomLogo };
}
